const RegProceduralGuaranteeCodes = {
  HojaReferidoEvaluaciónInicial: 326,
  CitaHistorialSocial: 327,
  ReciboDiscusiónDocumentoDerechosPadres: 325,
  AutorizaciónEvaluaciónInicial: 408,
};

export default RegProceduralGuaranteeCodes;
